import { create } from 'zustand';

// Store to manage the TV country availability
export type CountryStore = {
    includeTuvalu: boolean;
    allowedCountries: string[];
    vatRegexPatterns: Record<string, string>;
    setIncludeTuvalu: (include: boolean) => void;
    setAllowedCountries: (countries: string[]) => void;
    setVatRegexPatterns: (vatPatterns: Record<string, string>) => void;
    getAllowedCountries: () => string[];
};

export const useCountryStore = create<CountryStore>((set, get) => ({
    includeTuvalu: false,
    allowedCountries: [],
    vatRegexPatterns: {},
    setIncludeTuvalu: include => set({ includeTuvalu: include }),
    setAllowedCountries: countries => set({ allowedCountries: countries }),
    setVatRegexPatterns: vatPatterns => set({ vatRegexPatterns: vatPatterns }),
    getAllowedCountries: () => {
        const { allowedCountries, includeTuvalu } = get();
        return includeTuvalu ? [...allowedCountries, 'TV'] : allowedCountries;
    },
}));

// Helper function to initialize the country store based on initial state
export const initializeCountryStore = (
    initialCountry: string,
    allowedCountries: string[],
    vatPatterns: Record<string, string>
) => {
    const shouldIncludeTuvalu = initialCountry === 'TV';
    useCountryStore.getState().setAllowedCountries(allowedCountries);
    useCountryStore.getState().setIncludeTuvalu(shouldIncludeTuvalu);
    useCountryStore.getState().setVatRegexPatterns(vatPatterns);
};

// Export a function to get the current allowed countries
export const getAllowedCountries = () => useCountryStore.getState().getAllowedCountries();
